import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const SignInLayer = () => {
  const navigate = useNavigate();
  const { login, loading, error, clearError } = useAuth();
  
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [formError, setFormError] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    // Clear errors when user types
    if (formError) setFormError('');
    if (error) clearError();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError('');

    // Validation
    if (!formData.email.trim()) {
      setFormError('Email is required');
      return;
    }
    if (!formData.password) {
      setFormError('Password is required');
      return;
    }

    const result = await login(formData.email, formData.password);
    
    if (result.success) {
      navigate('/', { replace: true });
    }
  };

  const togglePassword = () => {
    setShowPassword(!showPassword);
    const passwordInput = document.getElementById('your-password');
    if (passwordInput) {
      passwordInput.type = showPassword ? 'password' : 'text';
    }
  };

  const displayError = formError || error;

  return (
    <section className='min-vh-100 d-flex align-items-center justify-content-center bg-white'>
      <div className='w-100' style={{maxWidth: '450px', padding: '20px'}}>
        <div className='text-center mb-6'>
          <Link to='/' className='d-inline-block mb-4'>
            <img src='/assets/images/logo.png' alt='Logo' style={{maxWidth: '250px'}} />
          </Link>
          <h5 className='mb-4'>Sign In to your Account</h5>
          <p className='mb-6 text-secondary text-sm'>
            Welcome back! please enter your detail
          </p>
        </div>

        {displayError && (
          <div className="alert alert-danger py-2 mb-3" role="alert">
            <small>{displayError}</small>
          </div>
        )}

        <form className="mt-3" onSubmit={handleSubmit}>
          <div className='icon-field mb-3'>
            <span className='icon top-50 translate-middle-y'>
              <Icon icon='mage:email' />
            </span>
            <input
              type='email'
              name='email'
              value={formData.email}
              onChange={handleChange}
              className='form-control bg-light'
              style={{height: '48px', fontSize: '0.875rem'}}
              placeholder='Email'
              disabled={loading}
            />
          </div>
          <div className='position-relative mb-3'>
            <div className='icon-field'>
              <span className='icon top-50 translate-middle-y'>
                <Icon icon='solar:lock-password-outline' />
              </span>
              <input
                type={showPassword ? 'text' : 'password'}
                name='password'
                value={formData.password}
                onChange={handleChange}
                className='form-control bg-light'
                style={{height: '48px', fontSize: '0.875rem', paddingRight: '40px'}}
                id='your-password'
                placeholder='Password'
                disabled={loading}
              />
            </div>
            <span
              className={`toggle-password cursor-pointer position-absolute end-0 top-50 translate-middle-y me-3 text-secondary ri-eye${showPassword ? '-off' : ''}-line`}
              onClick={togglePassword}
              style={{cursor: 'pointer'}}
            />
          </div>
              <div className='mb-3'>
  <div className='d-flex justify-content-between align-items-center gap-2'>
    <div className='form-check d-flex align-items-center'>
      <input
        className='form-check-input border border-secondary'
        type='checkbox'
        name='rememberMe'
        checked={formData.rememberMe}
        onChange={handleChange}
        id='remember' // Check spelling corrected
        style={{ fontSize: '0.875rem' }}
        disabled={loading}
      />
      <label className='form-check-label small ms-2' htmlFor='remember'>
        Remember me
      </label>
    </div>
    <Link to='/forgot-password' className='text-primary fw-medium small text-decoration-none'>
      Forgot Password?
    </Link>
  </div>
</div>
          <button
            type='submit'
            className='btn btn-primary w-100 mt-3 d-flex align-items-center justify-content-center'
            style={{height: '48px', fontSize: '0.875rem'}}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Signing In...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
      </div>
    </section>
  );
};

export default SignInLayer;